import { defineMessages } from 'react-intl';

const _default_1: {
	statusHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	statusHeading: {
		id: 'jira-workflow-editor.workflow-builder.status-heading',
		defaultMessage: 'Status',
		description:
			'Heading text displayed at the top of a status card or section in the Jira workflow wizard within the AI conversation interface. Shown as a section header or card title. The purpose is to identify the section that contains workflow status configuration options, helping users understand they are configuring a workflow status.',
	},
});
export default _default_1;
